<!-- Секції -->
<main>
  <section class="banner" id="banner">
    <div class="container-small">
      <div class="banner__wrapper">
        <div class="banner__info">
          <!-- <div class="banner__info--title">
            Your data <span>belongs to you</span>
          </div>
          <div class="banner__info--desc">
            Your private life doesn’t need to be online. We’ll help you <span>reclaim</span> your digital freedom and
            make your sensitive data vanish from the internet.
          </div> -->
          <div
            class="banner__info--title"
            [innerHTML]="'banner.title' | translate"
          ></div>
          <div
            class="banner__info--desc"
            [innerHTML]="'banner.desc' | translate"
          ></div>
        </div>
        <div class="banner__img">
          <img src="assets/images/banner.svg" alt="banner" />
        </div>
      </div>
    </div>
  </section>

  <section class="swiper" id="swiper">
    <div class="swiper__thumbs">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper__thumbs__item">
              <img
                src="assets/images/swiper-01.png"
                alt="slider-img-01"
                class="s-img-switch"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="swiper__thumbs__item">
              <img
                src="assets/images/swiper-03.jpg"
                alt="slider-img-01"
                class="s-img-switch"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="swiper__thumbs__item">
              <img
                src="assets/images/swiper-02.jpg"
                alt="slider-img-01"
                class="s-img-switch"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="swiper__info">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper__info__item">
              <div
                class="swiper__info__item--title"
                [innerHTML]="'swiper.slide1.title' | translate"
              >
                <!-- What does the internet <span>know about you?</span> -->
              </div>
              <div class="swiper__info__item--desc">
                <p [innerHTML]="'swiper.slide1.p1' | translate">
                  <!-- You’re being watched online, even if you’ve never signed up
                  for anything. -->
                </p>
                <p [innerHTML]="'swiper.slide1.p2' | translate">
                  <!-- Your name, contact details, addresses, family connections,
                  shopping habits, even photos – are often gathered by data
                  brokers without your knowledge. -->
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="swiper__info__item">
              <div
                class="swiper__info__item--title"
                [innerHTML]="'swiper.slide2.title' | translate"
              >
                <!-- Who are <span>data brokers?</span> -->
              </div>
              <div class="swiper__info__item--desc">
                <p [innerHTML]="'swiper.slide2.p1' | translate">
                  <!-- You’ve never heard of them - but they know everything about
                  you. -->
                </p>
                <p [innerHTML]="'swiper.slide2.p2' | translate">
                  <!-- Data brokers collect your personal information from websites,
                  apps, public records, and even your online shopping habits. -->
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="swiper__info__item">
              <div
                class="swiper__info__item--title"
                [innerHTML]="'swiper.slide3.title' | translate"
              >
                <!-- What happens to <span>your data?</span> -->
              </div>
              <div class="swiper__info__item--desc">
                <p [innerHTML]="'swiper.slide3.p1' | translate">
                  <!-- This information, often gathered quietly, packaged and sold by
                  data brokers to advertisers, marketers and even unknown third
                  parties- without your consent. -->
                </p>
                <p [innerHTML]="'swiper.slide3.p2' | translate">
                  <!-- We find your data – and make it disappear. -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </section>

  <section class="privacy" id="privacy">
    <div class="container">
      <div class="privacy__wrapper">
        <div class="privacy__title" [innerHTML]="'privacy.title' | translate">
          <!-- Privacy Starts with Knowing <span>What’s at Stake</span> -->
        </div>
        <div class="privacy__list">
          <div class="privacy__list--item">
            <div class="privacy__list--inner">
              <div
                class="privacy__list--title"
                [innerHTML]="'privacy.items.0.title' | translate"
              >
                <!-- Spam & Unwanted Messages -->
              </div>
              <div
                class="privacy__list--desc"
                [innerHTML]="'privacy.items.0.desc' | translate"
              >
                <!-- Public email and phone data may lead to more junk mail,
                robocalls, and unsolicited texts from marketers and unknown
                sources. -->
              </div>
            </div>
          </div>
          <div class="privacy__list--item">
            <div class="privacy__list--inner">
              <div
                class="privacy__list--title"
                [innerHTML]="'privacy.items.1.title' | translate"
              >
                <!-- Unwanted Ads & Targeting -->
              </div>
              <div
                class="privacy__list--desc"
                [innerHTML]="'privacy.items.1.desc' | translate"
              >
                <!-- Your online activity and purchase habits may be used to create
                detailed profiles and deliver hyper-targeted ads. -->
              </div>
            </div>
          </div>
          <div class="privacy__list--item">
            <div class="privacy__list--inner">
              <div
                class="privacy__list--title"
                [innerHTML]="'privacy.items.2.title' | translate"
              >
                <!-- Small Leak Noticeable Over Time -->
              </div>
              <div
                class="privacy__list--desc"
                [innerHTML]="'privacy.items.2.desc' | translate"
              >
                <!-- A few exposed details – like your name, location may be enough
                to piece together your identity. Over time, this may increase
                your online vulnerability. -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="stat" id="stat">
    <div class="stat__wrapper">
      <div class="stat__title" [innerHTML]="'stat.title' | translate">
        <!-- Don’t be just another <span>statistics</span> -->
      </div>
      <div class="stat__info">
        <div class="stat__main-img image">
          <img src="assets/images/stat-01.svg" alt="main-img" />
        </div>
        <div class="stat__left-top-img image">
          <img src="assets/images/stat-02.svg" alt="left-top-img" />
        </div>
        <div class="stat__right-top-img image">
          <img src="assets/images/stat-03.svg" alt="right-top-img" />
        </div>
        <div class="stat__left-bottom-img image">
          <img src="assets/images/stat-04.svg" alt="left-bottom-img" />
        </div>
        <div class="stat__right-bottom-img image">
          <img src="assets/images/stat-05.svg" alt="right-bottom-img" />
        </div>
        <div class="stat__left-top-info text">
          <div class="stat__number right">5000</div>
          <div
            class="stat__text right"
            [innerHTML]="'stat.brokers' | translate"
          >
            <!-- data broker companies worldwide -->
          </div>
          <a
            href="https://stratcomcoe.org/cuploads/pfiles/data_brokers_and_security_20-01-2020.pdf"
            target="_blank"
            class="right"
            [innerHTML]="'stat.readMore' | translate"
          >
            <!-- read more -->
          </a>
        </div>
        <div class="stat__right-top-info text">
          <div class="stat__number">96,8%</div>
          <div class="stat__text" [innerHTML]="'stat.spam' | translate">
            <!-- of people receive spam messages -->
          </div>
          <a
            href="https://www.emailtooltester.com/en/blog/spam-statistics/"
            target="_blank"
            [innerHTML]="'stat.readMore' | translate"
          >
            <!-- read more -->
          </a>
        </div>
        <div class="stat__left-bottom-info text">
          <div class="stat__number right">$389</div>
          <div class="stat__text right" [innerHTML]="'stat.market' | translate">
            <!-- billions is the value of the global data broker market -->
          </div>
          <a
            href="https://www.globenewswire.com/news-release/2024/11/15/2981819/0/en/Data-Broker-Market-Forecasts-2024-2029-Increasing-Demand-for-Targeted-Marketing-Rising-Penetration-of-IoT-with-North-America-Projected-to-Lead-Growth.html?utm_source=chatgpt.com"
            target="_blank"
            class="right"
            [innerHTML]="'stat.readMore' | translate"
          >
            <!-- read more -->
          </a>
        </div>
        <div class="stat__right-bottom-info text">
          <div class="stat__number">33%</div>
          <div class="stat__text" [innerHTML]="'stat.theft' | translate">
            <!-- of US citizens have been victims of identity theft -->
          </div>
          <a
            href="https://www.ic3.gov/AnnualReport/Reports/2021_IC3Report.pdf"
            target="_blank"
            [innerHTML]="'stat.readMore' | translate"
          >
            <!-- read more -->
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="removed" id="removed">
    <div class="container">
      <div class="removed__wrapper">
        <div class="removed__info">
          <div
            class="removed__info--title"
            [innerHTML]="'removed.title' | translate"
          >
            <!-- We contact data brokers to get
            <span>your personal info removed</span> -->
          </div>
          <div class="removed__info--subtitle">
            <p [innerHTML]="'removed.subtitle1' | translate">
              <!-- Deleting your data manually can take hours – just to get started. -->
            </p>
            <p [innerHTML]="'removed.subtitle2' | translate">
              <!-- But that’s only the beginning. -->
            </p>
            <p [innerHTML]="'removed.subtitle3' | translate">
              <!-- Here’s why
              <span>doing it alone is often more work than it’s worth:</span> -->
            </p>
          </div>
          <img
            src="assets/images/removed-icon.svg"
            class="removed__info--icon"
            alt="title-icon"
          />
        </div>
        <div class="removed__list">
          <div class="removed__list--item">
            <div class="removed__list--inner">
              <img
                src="assets/images/removed-01.svg"
                class="removed__list--icon"
                alt="icon"
              />
              <div
                class="removed__list--title"
                [innerHTML]="'removed.time.title' | translate"
              >
                <!-- Time Commitment -->
              </div>
              <div class="removed__list--manual">
                <div
                  class="removed__list--manual--title"
                  [innerHTML]="'removed.manual' | translate"
                >
                  <!-- <i class="icon ion-android-close"></i>
                  <span
                    style="margin-left: 5px"
                    [innerHTML]="'removed.manual' | translate"
                  >
                    Manual:
                  </span> -->
                </div>
                <div
                  class="removed__list--manual--desc"
                  [innerHTML]="'removed.time.manual' | translate"
                >
                  <!-- Research each broker, fill out forms, follow complex steps. -->
                </div>
              </div>
              <div class="removed__list--service">
                <div
                  class="removed__list--service--title"
                  [innerHTML]="'removed.service' | translate"
                >
                  <!-- <i class="icon ion-android-done"></i>
                  <span
                    style="margin-left: 5px"
                    [innerHTML]="'removed.service' | translate"
                  >
                    Our Service:
                  </span> -->
                </div>
                <div
                  class="removed__list--service--desc"
                  [innerHTML]="'removed.time.service' | translate"
                >
                  <!-- We automate the process – just sign up once. -->
                </div>
              </div>
            </div>
          </div>
          <div class="removed__list--item">
            <div class="removed__list--inner">
              <img
                src="assets/images/removed-02.svg"
                class="removed__list--icon"
                alt="icon"
              />
              <div
                class="removed__list--title"
                [innerHTML]="'removed.reappear.title' | translate"
              >
                <!-- Reappearance of Data -->
              </div>
              <div class="removed__list--manual">
                <div
                  class="removed__list--manual--title"
                  [innerHTML]="'removed.manual' | translate"
                >
                  <!-- <i class="icon ion-android-close"></i>
                  Manual: -->
                </div>
                <div
                  class="removed__list--manual--desc"
                  [innerHTML]="'removed.reappear.manual' | translate"
                >
                  <!-- Many sites republish info – keep checking and resubmitting. -->
                </div>
              </div>
              <div class="removed__list--service">
                <div
                  class="removed__list--service--title"
                  [innerHTML]="'removed.service' | translate"
                >
                  <!-- <i class="icon ion-android-done"></i>
                  Our Service: -->
                </div>
                <div
                  class="removed__list--service--desc"
                  [innerHTML]="'removed.reappear.service' | translate"
                >
                  <!-- We monitor and re-request removals for you. -->
                </div>
              </div>
            </div>
          </div>
          <div class="removed__list--item">
            <div class="removed__list--inner">
              <img
                src="assets/images/removed-03.svg"
                class="removed__list--icon"
                alt="icon"
              />
              <div
                class="removed__list--title"
                [innerHTML]="'removed.finding.title' | translate"
              >
                <!-- Finding Data Brokers -->
              </div>
              <div class="removed__list--manual">
                <div
                  class="removed__list--manual--title"
                  [innerHTML]="'removed.manual' | translate"
                >
                  <!-- <i class="icon ion-android-close"></i>
                  Manual: -->
                </div>
                <div
                  class="removed__list--manual--desc"
                  [innerHTML]="'removed.finding.manual' | translate"
                >
                  <!-- There are thousands out there. Most people don’t know where to
                  begin. -->
                </div>
              </div>
              <div class="removed__list--service">
                <div
                  class="removed__list--service--title"
                  [innerHTML]="'removed.service' | translate"
                >
                  <!-- <i class="icon ion-android-done"></i>
                  Our Service: -->
                </div>
                <div
                  class="removed__list--service--desc"
                  [innerHTML]="'removed.finding.service' | translate"
                >
                  <!-- We scan across dozens of known data broker sites instantly. -->
                </div>
              </div>
            </div>
          </div>
          <div class="removed__list--item">
            <div class="removed__list--inner">
              <img src="assets/images/removed-04.png" alt="icon" />
              <div
                class="removed__list--title"
                [innerHTML]="'removed.peace.title' | translate"
              >
                <!-- Peace and Confidence -->
              </div>
              <div class="removed__list--manual">
                <div
                  class="removed__list--manual--title"
                  [innerHTML]="'removed.manual' | translate"
                >
                  <!-- <i class="icon ion-android-close"></i>
                  Manual: -->
                </div>
                <div
                  class="removed__list--manual--desc"
                  [innerHTML]="'removed.peace.manual' | translate"
                >
                  <!-- Uncertainty about what’s still out there. -->
                </div>
              </div>
              <div class="removed__list--service">
                <div
                  class="removed__list--service--title"
                  [innerHTML]="'removed.service' | translate"
                >
                  <!-- <i class="icon ion-android-done"></i>
                  Our Service: -->
                </div>
                <div
                  class="removed__list--service--desc"
                  [innerHTML]="'removed.peace.service' | translate"
                >
                  <!-- Set it and forget it – we’ll do the follow-up for you. -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="streamline" id="streamline">
    <div class="container-small">
      <div class="streamline__wrapper">
        <div
          class="streamline__title"
          [innerHTML]="'streamline.title' | translate"
        >
          <!-- Skip the hassle – we’ve streamlined everything to make it effortless
          for you -->
        </div>
        <div class="streamline__list">
          <img
            src="assets/images/streamline-curve.svg"
            class="streamline__list--curve"
            alt="icon"
          />
          <div class="streamline__list--item">
            <div class="streamline__list--inner">
              <div class="streamline__list--top">
                <div class="streamline__list--top--info">
                  <div class="streamline__list--number">01</div>
                  <div
                    class="streamline__list--title"
                    [innerHTML]="'streamline.step1.title' | translate"
                  >
                    <!-- Submit your info -->
                  </div>
                </div>
                <img
                  src="assets/images/streamline-01.svg"
                  class="streamline__list--icon"
                  alt="icon"
                />
              </div>
              <div
                class="streamline__list--desc"
                [innerHTML]="'streamline.step1.desc' | translate"
              >
                <!-- Enter your basic info – we'll handle the removals across search
                engines and data broker platforms. -->
              </div>
            </div>
          </div>
          <div class="streamline__list--item">
            <div class="streamline__list--inner">
              <div class="streamline__list--top">
                <div class="streamline__list--top--info">
                  <div class="streamline__list--number">02</div>
                  <div
                    class="streamline__list--title"
                    [innerHTML]="'streamline.step2.title' | translate"
                  >
                    <!-- Scan & Detect -->
                  </div>
                </div>
                <img
                  src="assets/images/streamline-02.svg"
                  class="streamline__list--icon"
                  alt="icon"
                />
              </div>
              <div
                class="streamline__list--desc"
                [innerHTML]="'streamline.step2.desc' | translate"
              >
                <!-- We search dozens of known data broker sites to find where your
                personal information is publicly listed. -->
              </div>
            </div>
          </div>
          <div class="streamline__list--item">
            <div class="streamline__list--inner">
              <div class="streamline__list--top">
                <div class="streamline__list--top--info">
                  <div class="streamline__list--number">03</div>
                  <div
                    class="streamline__list--title"
                    [innerHTML]="'streamline.step3.title' | translate"
                  >
                    <!-- Request Removals -->
                  </div>
                </div>
                <img
                  src="assets/images/streamline-03.svg"
                  class="streamline__list--icon"
                  alt="icon"
                />
              </div>
              <div
                class="streamline__list--desc"
                [innerHTML]="'streamline.step3.desc' | translate"
              >
                <!-- Our team prepares and submits removal requests on your behalf –
                no forms or legal language needed from you. -->
              </div>
            </div>
          </div>
          <div class="streamline__list--item">
            <div class="streamline__list--inner">
              <div class="streamline__list--top">
                <div class="streamline__list--top--info">
                  <div class="streamline__list--number">04</div>
                  <div
                    class="streamline__list--title"
                    [innerHTML]="'streamline.step4.title' | translate"
                  >
                    <!-- Monitor & Recheck -->
                  </div>
                </div>
                <img
                  src="assets/images/streamline-04.svg"
                  class="streamline__list--icon"
                  alt="icon"
                />
              </div>
              <div
                class="streamline__list--desc"
                [innerHTML]="'streamline.step4.desc' | translate"
              >
                <!-- We continuously monitor for reappearance and re-submit takedown
                requests as needed. -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="track" id="track">
    <div class="track__bg">
      <img
        src="assets/images/track-01.jpg"
        class="s-img-switch"
        alt="track-01"
      />
    </div>
    <img
      src="assets/images/dashboard_preview.png"
      class="track__img"
      alt="track-02"
    />
    <div class="container">
      <div class="track__wrapper">
        <div class="track__info">
          <div class="track__title" [innerHTML]="'track.title' | translate">
            <!-- Track your data removal <span>in real time</span> -->
          </div>
          <div class="track__desc">
            <p [innerHTML]="'track.desc1' | translate">
              <!-- Your personal dashboard keeps you informed every step of the way –
              showing live updates on which brokers we've contacted, what’s
              still pending, and what’s been removed. -->
            </p>
            <p [innerHTML]="'track.desc2' | translate">
              <!-- With a clean, easy-to-use layout, you’ll always know how your
              privacy is being protected. -->
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
